import { render } from "./RegistroUbicaciones.vue?vue&type=template&id=5bf066ae&scoped=true"
import script from "./RegistroUbicaciones.vue?vue&type=script&lang=js"
export * from "./RegistroUbicaciones.vue?vue&type=script&lang=js"

import "./RegistroUbicaciones.vue?vue&type=style&index=0&id=5bf066ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf066ae"]])

export default __exports__